import React from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from 'react-bootstrap';
import { authUtils } from "./authUtils";

function SignIn() {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <>
      {auth.activeNavigator === "signinSilent" ? (
        <span>signing you in...</span>
      ) : auth.activeNavigator === "signoutRedirect" ? (
        <span>signing you out...</span>
      ) : auth.isLoading ? (
        <Spinner
          animation="border"
          role="status"
          style={{ marginRight: "1rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : auth.error ? (
        <span>Ooops... {auth.error.message}</span>
      ) : auth.isAuthenticated ? (
        <Button
          type="button"
          onClick={() => auth.removeUser().then(() => navigate("/"))}
          style={{ marginRight: "1rem" }}
        >
          <span className="icon-user"></span>Sign out {authUtils.getName(auth)}
        </Button>
      ) : (
        <Button
          type="button"
          onClick={() =>
            auth.signinRedirect({
              extraQueryParams: { prompt: "select_account" },
            })
          }
          style={{ marginRight: "1rem" }}
        >
          <span className="icon-user"></span>Sign in
        </Button>
      )}
    </>
  );
}

export default SignIn;
